import { render, staticRenderFns } from "./UploadAttributesMenu.vue?vue&type=template&id=49fb7814&"
import script from "./UploadAttributesMenu.vue?vue&type=script&lang=js&"
export * from "./UploadAttributesMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports